export const adjustColor = {
    methods: {
        //5 waardes waar de kleur zich aanpast
        adjustColor(percent) {
            if (percent >= 80) {
              return "rgb(99,255,0)";
            } else if (percent >= 60 && percent < 80) {
              return "rgb(173,255,0)";
            } else if (percent >= 40 && percent < 60) {
              return "rgb(255,255,0)";
            } else if (percent >= 20 && percent < 40) {
              return "rgb(255,193,0)";
            } else {
              return "rgb(255,0,0)";
            }
          }
    }
}

